export const roadAssistancePath = '/settings/road-assistance'
